<template>
    <div class="heightWaybill">
      <height-waybill-tabs></height-waybill-tabs>
      <height-waybill-container></height-waybill-container>
    </div>
</template>
<script>
import HeightWaybillTabs from '@/components/heightWaybill/Tabs.vue'
import HeightWaybillContainer from '@/components/heightWaybill/Container.vue'
export default {
  name: 'heightWaybill',
  components: {
    HeightWaybillTabs,
    HeightWaybillContainer
  }
}
</script>
<style lang="stylus">
.heightWaybill
  height 100%
</style>
